import { render, staticRenderFns } from "./menuV2.vue?vue&type=template&id=78908acf&scoped=true&"
import script from "./menuV2.vue?vue&type=script&lang=js&"
export * from "./menuV2.vue?vue&type=script&lang=js&"
import style0 from "./menuV2.vue?vue&type=style&index=0&id=78908acf&scoped=true&lang=scss&"
import style1 from "./menuV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78908acf",
  null
  
)

export default component.exports